/**
 * @module builder
 */

import type { OptionsDocument, QuoteDocument } from 'paintscout'
import { bulkOperateLineItem } from '../bulk-operate-line-item/bulk-operate-line-item'
import { updateLineItem } from '../../line-items'
import type { LineItemOperation } from '../'

export function handleLineItemOperations(args: {
  quote: QuoteDocument
  options: OptionsDocument
  lineItemOperations: LineItemOperation[]
}): QuoteDocument {
  const { quote, options, lineItemOperations } = args
  let currentQuote = quote
  lineItemOperations.forEach((operation: LineItemOperation) => {
    const newLineItem = bulkOperateLineItem(operation)
    // need to update the line item with the new products, then pass it into updateLineItem
    const updatedQuote = updateLineItem({ quote: currentQuote, options, item: newLineItem })
    currentQuote = updatedQuote
  })
  return currentQuote
}
